import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Energyflat } from './energyflat.model';
import { EnergyflatService } from './energyflat.service';
@Injectable()
export class EnergyflatPopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private energyflatService: EnergyflatService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.energyflatService.find(id).subscribe((energyflat) => {
                energyflat.validFrom = this.datePipe
                    .transform(energyflat.validFrom, 'yyyy-MM-ddThh:mm');
                energyflat.updated = this.datePipe
                    .transform(energyflat.updated, 'yyyy-MM-ddThh:mm');
                energyflat.created = this.datePipe
                    .transform(energyflat.created, 'yyyy-MM-ddThh:mm');
                this.energyflatModalRef(component, energyflat);
            });
        } else {
            return this.energyflatModalRef(component, new Energyflat());
        }
    }

    energyflatModalRef(component: Component, energyflat: Energyflat): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.energyflat = energyflat;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/energyflat/energyflat-popup.service.ts